export const PERFORMANCE_EVALUATION_CONSTANTS = {
  IMAGES: {
    NO_DATA_FOUND: 'assets/img/no-data-found.png',
  },
  MODAL_CLASSES: {
    DIM_BACKGROUND: 'dim-background',
  },
  CSS_CLASSES: {
    RED_TEXT: 'red-text',
    BLACK_TEXT: 'black-text',
    GREEN_TEXT: 'green-text',
  },
  LABELS: {
    PERFORMANCE_EVALUATION_TITLE: 'Performance Evaluation',
    SEARCH: 'Search',
    SELECT_ITEM: 'Select Item',
    GET_CALENDAR: 'Get Calendar',
    HOURS_SUFFIX: ' Hrs',
    OK: 'OK',
  },
  IDS: {
    MONTH_SELECT: 'month_select',
  },
  ICONS: {
    SEARCH: 'search',
    CLOSE: 'close',
    DATE_RANGE: 'date_range',
    FLAG: 'flag',
  },
  TEMPLATE: {
    HOURS_SUFFIX: ' Hrs',
    HOURS_SHORT: 'Hrs'
  },
  MESSAGES: {
    NO_SELECTION_TITLE: 'No Selection',
    FAILED_LOAD_COMMENTS: 'Failed to load leave comments',
    FAILED_SAVE_COMMENT: 'Failed to save comment',
    COMMENT_SAVED_SUCCESS: 'Comment saved successfully',
    FAILED_LOAD_TIMESHEET: 'Failed to load performance evaluation details',
  },
  TITLES: {
    SUCCESS: 'Success',
    ERROR: 'Error',
    LOAD_ERROR: 'Load Error',
    SAVE_ERROR: 'Save Error',
  },

} as const;
